/* import __COLOCATED_TEMPLATE__ from './errors-collection.hbs'; */
import Component from "@ember/component";
export default Component.extend({
  tagName: ""
});